import React from 'react'

const Pricing = () => {
  return (
    <section className="pricing-section">
  <div className="auto-container">
    <div className="sec-title text-center">
      <span className="sub-title">GET TICKET</span>
      <h2>
        Explore Flexible Pricing Plans <br />
        Choose a Ticket
      </h2>
      <span className="divider" />
    </div>
    <div className="row">
      {/* Pricing block */}
      <div
        className="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
        data-wow-delay="400ms"
      >
        <div className="inner-box">
          <h3>Donate</h3>
          <div className="price">
            {" "}
            <sup>$</sup>200<sub>USD</sub>
          </div>
          <ul className="features">
            <li>Concert Attendance</li>
            <li>20 Lottery Ticket</li>
            <li>Priority Seating</li>
            <li>5 Person Entry</li>
            <li>Certificate</li>
            <li>T-Shart</li>
          </ul>
          <button className="theme-btn btn-style-one">
            <span className="btn-title">Donate</span>
          </button>
        </div>
      </div>
      {/* Pricing block */}
      <div className="pricing-block tagged col-lg-4 col-md-6 col-sm-12 wow fadeInUp">
        <div className="inner-box">
          <h3>Donate</h3>
          <div className="price">
            {" "}
            <sup>$</sup>400<sub>USD</sub>
          </div>
          <ul className="features">
            <li>Concert Attendance</li>
            <li>40 Lottery Ticket</li>
            <li>Priority Seating</li>
            <li>7 Person Entry</li>
            <li>Certificate</li>
            <li>T-Shart</li>
          </ul>
          <button className="theme-btn btn-style-two">
            <span className="btn-title">Donate</span>
          </button>
        </div>
      </div>
      {/* Pricing block */}
      <div
        className="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
        data-wow-delay="400ms"
      >
        <div className="inner-box">
          <h3>Donate</h3>
          <div className="price">
            {" "}
            <sup>$</sup>600<sub>USD</sub>
          </div>
          <ul className="features">
            <li>Concert Attendance</li>
            <li>70 Lottery Ticket</li>
            <li>Priority Seating</li>
            <li>9 Person Entry</li>
            <li>Certificate</li>
            <li>T-Shart</li>
          </ul>
          <button className="theme-btn btn-style-one">
            <span className="btn-title">Donate</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default Pricing